import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Localization } from "../../common/Localization";
import { useHistory } from 'react-router-dom';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    Lookup,
    StateStoring

} from "devextreme-react/data-grid";
import "jspdf-autotable";
import { formatMessage } from 'devextreme/localization';
import { Button, SelectBox, TextArea } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import { GridLayout } from "../../common/GridLayout";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { INVENTORY_OPERATIONS, filterVisibleOperations } from "./inventoryOperations";
let availableFlag = "";
function TransactionEntryGrid(props) {
    const dataGrid = useRef(null);
    const gridKey = "22FFAA37-47F6-4AB2-ACFB-782C6EAA53B6";
    const history = useHistory();
    const [isMobileView, setIsMobileView] = useState(false);
    const allowedPageSizes = [5, 10, 20, 100, "all"];
    const rowId = useRef(null);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedOperation, setSelectedOperation] = useState([]);
    // Operations hidden for the user's role (Manage Settings -> Inventory Management) are
    // dropped from the per-row "Operation Type" picker. Empty/missing claim => all visible.
    const InventoryOperationTypes = filterVisibleOperations(
        INVENTORY_OPERATIONS,
        props.oidc?.user?.profile?.IMHIDDENOPERATIONS
    ).map((op) => ({ id: op.Id, name: op.Name }));

    var accessToken = props.oidc.user.access_token;
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
                setIsEditButtonDisabled(false);
            }
        }
    };
    const onEditingStart = (e) => {
        if (e.key != null && e.key != undefined && !dataGrid.current.instance().isRowSelected(e.key)) {
            dataGrid.current.instance().selectRows([e.key], false);
        }

    };
    const handleCellValueChanged = (data) => {

        setSelectedItemKeys(data.selectedRowKeys);
        if (data.selectedRowKeys && data.selectedRowKeys.length == 1) {
            rowId.current = data.selectedRowKeys[0];
            setIsEditButtonDisabled(false);
            setSelectedOperation(data.selectedRowsData[0]);
        }
        else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }

    }
    const onInitNewRow = (e) => {
        if (!e.data.availableflag) {
            e.data.availableflag = "Y";
            e.data.availableflagDiscription = "Yes";;
        }
        // e.data.operationType = 2;
    };
    const handleOperationClick = () => {

        var opertion = selectedOperation.operationType;
        const buttonUrl = "/im/InventoryOperation?id=" + rowId.current + "&selectedOperation=" + opertion;
        history.push(buttonUrl);
    };
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 768);  
      };
      useEffect(() => {
        updateView();
        window.addEventListener("resize", updateView);
        return () => {
          window.removeEventListener("resize", updateView);
        };
      }, []);
    return (
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            id="gridContainer"
            dataSource={props.dataSource}
            ref={dataGrid}
            selectedRowKeys={selectedItemKeys}
            showBorders={true}
            rowAlternationEnabled={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            onSelectionChanged={handleCellValueChanged}
            onInitNewRow={onInitNewRow}
            // onEditingStart={onEditingStart}
            onContentReady={onContentReady}

            className={props.searchPanelStatus ? "mobileGridHeightOpen" : "mobileGridHeightClose"}
        >
            <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
            >
                <ColumnChooserSearch
                    enabled={true}
                    editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
            />
            <Scrolling mode="standard" />
            <Selection mode="single" />
            <Export enabled={true} allowExportSelectedData={true} />
            <Editing
                mode="cell"
                refreshMode="repaint"
                allowUpdating={true}
                allowAdding={true}
            />
            <Paging defaultPageSize={5} />
            <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
            />
            <FilterRow visible={true} />
            <Column dataField="itemcode" allowEditing={false} caption={Localization.formatMessage('IMITEM.ITEMCODE', 'Item')} hidingPriority={17} />
            <Column dataField="description1" allowEditing={false} caption={Localization.formatMessage('IMITEM.DESCRIPTION_1', 'Description- 1')} hidingPriority={16} />
            <Column dataField="description2" allowEditing={false} caption={Localization.formatMessage('IMITEM.DESCRIPTION_2', 'Description- 2')} hidingPriority={15} />
            <Column dataField="classcode" allowEditing={false} caption={Localization.formatMessage('IMITEM.CLASSCODE', 'Class Code')} hidingPriority={14} />
            <Column dataField="lotcode" allowEditing={false} caption={Localization.formatMessage('IMLOT.LOTCODE', 'Lot')} hidingPriority={13} />
            <Column dataField="locationCode" allowEditing={false} caption={Localization.formatMessage('IMLOT.LOCATIONCODE', 'Location')} hidingPriority={12} />
            <Column dataField="size1" allowEditing={false} caption={Localization.formatMessage('IMITEM.SIZE_1', 'Size')} hidingPriority={11} />
            {/* Move From/To validate against On Hand, so On Hand is the working "Quantity" (brought up front);
                the former available-based "Quantity" column is relabeled "Available". */}
            <Column dataField="onHand" allowEditing={false} caption={formatMessage('Quantity')} format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={10}></Column>
            <Column dataField="quantity" allowEditing={false} caption='Available' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={9}></Column>
            <Column dataField="growing" allowEditing={false} caption='Growing' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={8}></Column>
            <Column dataField="forSale" allowEditing={false} caption='For Sale' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={7}></Column>
            <Column dataField="inReceiving" allowEditing={false} caption='In Receiving' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={6}></Column>
            <Column dataField="outShipped" allowEditing={false} caption='In Shipped' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={5}></Column>
            <Column dataField="inOrdered" allowEditing={false} caption='Pending Rec' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={4}></Column>
            <Column dataField="outOrdered" allowEditing={false} caption='Pending Ship' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={3}></Column>
            <Column dataField="netavailable" allowEditing={false} caption='Net Available' format={{
                type: 'fixedPoint',
                precision: 0,
                useGrouping: true
            }} hidingPriority={2}></Column>
            <Column dataField="status" allowEditing={false} caption='Status' hidingPriority={1} />
            <Column
                dataField="operationType"
                caption="Operation Type"
                width={100}
                allowEditing={false}
                cellRender={({ data }) => (
                    <SelectBox
                        dataSource={InventoryOperationTypes}
                        valueExpr="id"
                        displayExpr="name"
                        width='150px'
                        value={data.operationType}
                        onValueChanged={(e) => {
                            data.operationType = e.value;
                            const updatedSelectedOperation = {
                                ...data,
                                operationType: e.value,
                            };
                            setSelectedOperation(updatedSelectedOperation);
                        }}
                    />
                )}
            />
            <Column
                caption="Operation"
                width={100}
                alignment="center"
                allowSorting={false}
                allowFiltering={false}
                cellRender={({ data }) => (
                    <Button
                        text="Operation"
                        type="default"
                        stylingMode="contained"
                        disabled={isEditButtonDisabled}
                        onClick={() => handleOperationClick()}
                    />
                )}
            />

            <Toolbar>
                <Item location="before">
                    <Button className="accordianButton" disabled={isEditButtonDisabled} onClick={handleOperationClick} type="default" text="Operation" />
                </Item>
                <Item location="after" visible={!isMobileView}>
                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
            </Toolbar>
        </DataGrid>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(TransactionEntryGrid);
